module.exports = __webpack_public_path__ + "img/arrow-down.33772da3.svg";